// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1>Card Declined</h1>
        </div>
        <div class="hoa-dialog__main">
            <div [innerHTML]="data.errorMessage" tid="bankTokenErrorBody"></div>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--blue Button--minWidth130" (click)="closeThisDialog(0)">OK</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;